export const COMPLETE_BACKUP_EXPORT_VERSION = '2.2';

export function buildCompleteBackupPayload({
    currentUser,
    projects,
    tasks,
    dependencies,
    projectColors,
    projectColorOverrides,
    tagColors,
    tagColorOverrides,
    tagColorsVersion,
    sortMode,
    manualTaskOrder,
    settings,
    history,
    projectCounter,
    taskCounter,
}) {
    const safeProjects = Array.isArray(projects) ? projects : [];
    const safeTasks = Array.isArray(tasks) ? tasks : [];
    const completedTasks = safeTasks.filter(task => task.status === 'done').length;

    return {
        user: currentUser ? {
            id: currentUser.id,
            username: currentUser.username,
            name: currentUser.name,
            email: currentUser.email
        } : null,
        projects: safeProjects,
        tasks: safeTasks,
        dependencies: dependencies || {},
        projectColors: projectColors || {},
        projectColorOverrides: projectColorOverrides || {},
        tagColors: tagColors || {},
        tagColorOverrides: tagColorOverrides || {},
        tagColorsVersion: Number.isFinite(Number(tagColorsVersion)) ? Number(tagColorsVersion) : 0,
        sortMode: sortMode || 'priority',
        manualTaskOrder: manualTaskOrder || {},
        settings: settings || {},
        history: Array.isArray(history) ? history : [],
        projectCounter: Number.isFinite(Number(projectCounter)) ? Number(projectCounter) : 1,
        taskCounter: Number.isFinite(Number(taskCounter)) ? Number(taskCounter) : 1,
        statistics: {
            totalProjects: safeProjects.length,
            totalTasks: safeTasks.length,
            completedTasks,
            completionRate: safeTasks.length > 0 ? ((completedTasks / safeTasks.length) * 100).toFixed(1) : 0
        },
        exportDate: new Date().toISOString(),
        exportVersion: COMPLETE_BACKUP_EXPORT_VERSION,
        sourceSystem: 'Nautilus Multi-User'
    };
}
